module.exports = __webpack_public_path__ + "4abd4e0ec371bb5297fe71c4bb54f188.pdf";